// extracted by mini-css-extract-plugin
export default {"topicSelect":"styles_topicSelect__VYiKA","topicSelectSelection":"styles_topicSelectSelection__BXYh9","fadeIn":"styles_fadeIn__rf0w9"};